import { Contact as ContactRequestData } from "@aviv-ipp/bff-types"
import { Brand } from "@aviv-ipp/bff-types/src/brand"

import { LogError } from "../utils/logging"
import { brandifyedUrl } from "./brandifyedUrl"

export type ContactResponse = { message: string }

export async function postRequest<T, R>(url: string, requestData: T, _fetch = fetch): Promise<R> {
  const body = JSON.stringify(requestData)
  const response = await _fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body,
  })

  if (!response.ok) {
    LogError(`An error occurred while posting the data on ${url} with ${body}`)
    throw new Error("An error occurred.")
  }

  return await response.json()
}

export const postContactRequest = async (
  data: Omit<ContactRequestData, "portal" | "partnerId">,
  bffBaseUrl: string,
  legacyCustomerId: string,
  brand: Brand
): Promise<ContactResponse> => {
  const contactRequestEndpoint = brandifyedUrl(`${bffBaseUrl}/contact`, brand)
  try {
    return await postRequest<ContactRequestData, ContactResponse>(contactRequestEndpoint, {
      ...data,
      portal: mapPortal(brand),
      partnerId: legacyCustomerId,
    })
  } catch (error: any) {
    LogError(error.message, error as Error)
    throw new Error(error.message)
  }
}

const mapPortal = (brand: Brand) => {
  switch (brand) {
    case "immonet":
      return "IMN-DEU"
    case "immowelt":
      return "IWT-DEU"
    default:
      return "IWB-BEL"
  }
}
